<!-- 模型中心 — 创建模型、训练模型、校验模型、发布模型 -->
<template>
  <div class="pretrain-operate model-operate">
    <div class="pretrain-header header">
      <h3 class="title">
        {{ pageTitle[operate].label }}
        <span class="see-text" v-if="pageTitle[operate].viewProcess" @click="onClickSee(pageTitle[operate].label)">{{ pageTitle[operate].viewProcess }}</span>
        <el-button 
          type="primary"
          class="btn-primary"
          v-if="pageTitle[operate].label === '训练模型' && (modelType == 1 || modelType == 2)"
          @click="onClickConfiguration"
        >训练配置</el-button>
      </h3>
    </div>
    <div class="main">
      <!-- 创建模型 create -->
      <div class="create" v-if="operate === 'create'">
        <div class="intxt intxt-bottom">
          <label class="label" for> <i class="required">*</i>模型名称： </label>
          <el-input
            class="input"
            placeholder="请输入模型名称"
            v-model.trim="Create.modelName"
            maxlength="20"
            show-word-limit
          />
        </div>
        <div class="intxt">
          <label class="label" for> <i class="required">*</i>模型描述： </label>
          <el-input
            type="textarea"
            :rows="9"
            maxlength="200"
            show-word-limit
            placeholder="请输入模型描述"
            v-model.trim="Create.modelFuncDesc"
          />
        </div>
        <div class="btns">
          <el-button type="primary" class="btn-primary" @click="createModel"
            >确定</el-button
          >
          <el-button type="info" class="btn-cancel" @click="createModelCancel"
            >取消</el-button
          >
        </div>
      </div>

      <!-- 训练模型 training -->
      <div class="training" v-if="operate === 'training'">
        <div class="intxt">
          <label class="label" for>
            <i class="required">*</i>选择训练模型：
          </label>
          <el-select
            class="select-box select-box-training"
            v-model="activeModel"
            placeholder="请选择训练模型"
            filterable
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="intxt select-box">
          <label class="label" for>
            <i class="required">*</i>选择模型数据：
          </label>
          <el-select
            class="select-box select-box-training"
            v-model="datasetName"
            placeholder="请选择模型数据"
            filterable
          >
            <el-option
              v-for="item in dataSetOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <router-link
            class="go-create-dataset"
            :to="{ name: 'dataset-list', params: { modeltype: modelType, create: 'create' } }"
            >没有数据集，点击创建</router-link
          >
        </div>
        <div class="intxt select-box">
          <label class="label" for>
            <i class="required">*</i>选择数据集版本：
          </label>
          <el-select
            class="select-box select-box-training"
            v-model="activeDataset"
            placeholder="请选择数据集版本"
            filterable
          >
            <el-option
              v-for="item in versionList"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="intxt">
          <label class="label checkbox-label" ></label>
          <el-checkbox-group
            class="checkbox"
            v-model="Training.tags"
            @change="selectTrainingTags"
          >
            <el-checkbox
              v-for="(item, idx) in Label.records"
              :label="item.labelId"
              :key="item.labelId || idx"
              >{{ item.labelName }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
        <div class="tips" v-show="isMoreThan.val && Label.records">
          <div class="error">
            <i>+</i>
            <span
              >训练模型至少需要选中<b> {{ isMoreThan.limit }} </b>个标签</span
            >
          </div>
        </div>
        <div class="tips" v-if="unfinished">
          <div class="error">
            <i>+</i>
            <span>{{ `[${unfinishedLabl}]` }}{{ trainingRuleTips(modelType) }} </span>
          </div>
        </div>
        <div class="btns">
          <el-button type="primary" class="btn-primary" @click="trainingStart">开始训练</el-button>
        </div>
        <!-- 训练模型流程 -->
        <training-model-process v-if="!trainingNoTips && trainingModelProcessShow" :modelType="modelType" @toTrainingModelPage="toTrainingModelPage"></training-model-process>
      </div>
      
      <!-- 校验模型 verify -->
      <div class="verify" v-if="operate === 'verify'">
        <div class="verify-inner">
          <div class="intxt">
            <label class="label" for>
              <i class="required">*</i>选择校验模型：
            </label>
            <el-select
              class="select-box"
              v-model="activeModel"
              placeholder="请选择校验模型"
              filterable
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="intxt select-box">
            <label class="label" for>
              <i class="required">*</i>选择模型版本：
            </label>
            <el-select
              class="select-box"
              v-model="activeTrainingModel"
              placeholder="请选择模型版本"
              filterable
            >
              <el-option
                v-for="item in versionOptions2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>

          <div v-if="modelType == 2">
            <div class="nav-label-checkbox">
              <ul>
                <li>模型标签<span>：</span></li>
                <li v-for="item in navCheckList" :key="item" @click="onSelectNavState(item)">
                  <span>{{item}}</span>
                </li>
              </ul>
            </div>
            <ul class="list-tags" v-if="verifyResultImg && verifyResultImg[preview.index]">
              <li class="label-li" v-for="(item, idx) in verifyResultImg[preview.index].labelList" :key="idx">
                <i :class="[item.labelState ? 'el-icon-check i-select' : '']" :style="{'background':item.labelState?item.labelColor:'#fff',   'border-color':item.labelColor}" @click.stop="onSelectLabel(item.labelName)"></i>
                <span>{{ item.labelName }}</span>
              </li>
            </ul>
            <div class="line"></div>
          </div>

          <div
            class="verify-upload"
            v-show="activeModel && activeTrainingModel && !verificationModelProcessShow"
          >
            <el-button
              type="primary"
              class="btn-upload btn-primary"
              @click="uploadForVerify"
              >上传{{modelTypeCompany(modelType)}}</el-button
            >
            <div class="verify-total">
              <span> <i class="required">*</i>{{modelTypeCompany(modelType)}}数量： </span>
              <span>{{ uploadFilePreview.length }}</span>
            </div>
            <div class="upload-img" v-if="modelType == 1 || modelType == 2">
              <!-- 图片滑动 -->
              <columns-slider
                class="slider"
                :pictures="uploadFilePreview"
                :active-image="preview"
                @image-click="activePreview"
                @prev="sliderPrev"
                @next="sliderNext"
                ref="imgSliderPrev"
              />
              <div class="figure">
                <div class="figure-box">
                  <button class="btn-del" @click="removePreview(preview)" title="删除">
                    <span class="icon-del"></span>
                    <!-- <icon-base v-bind="Icons.trashCan">
                      <icon-trash-can />
                    </icon-base> -->
                  </button>
                  <img v-if="modelType == 1" :src="preview.imgUrl" alt />
                  <!-- 图片标注插件 -->
                  <label-region-testModel
                    v-if="modelType == 2 && verifyResultImg"
                    :image="preview"
                    :img-tag="verifyResultImg[preview.index]"
                    ref="imgLabelRegion"
                  ></label-region-testModel>
                </div>
              </div>
            </div>
            <div class="upload-img" v-if="modelType == 3 || modelType == 4">
              <!-- 文本滑动 -->
              <txt-slider
                class="slider"
                :pictures="uploadFilePreview"
                :active-image="preview"
                @image-click="activePreview"
                @prev="sliderPrev"
                @next="sliderNext"
                ref="txtSliderPrev"
              />
              <div class="figure">
                <div class="figure-box">
                  <button class="btn-del" @click="removePreview(preview)" title="删除">
                    <span class="icon-del"></span>
                  </button>
                  <div class="figure-text" v-html="textPreview"></div>
                </div>
              </div>
            </div>
            <div class="upload-img" v-if="modelType == 5 || modelType == 6">
              <!-- 音频滑动 -->
              <audio-slider
                class="slider"
                :pictures="uploadFilePreview"
                :active-image="preview"
                @image-click="activePreview"
                @prev="sliderPrev"
                @next="sliderNext"
                ref="audioSliderPrev"
              />
              <div class="figure audio-area-height">
                <div class="figure-box">
                  <button class="btn-del" @click="removePreview(preview)" title="删除">
                    <span class="icon-del"></span>
                  </button>
                  <!-- 音频波纹播放区 -->
                  <audio-play-area v-if="modelType == 5" :currentAudioUrl="currentAudioUrl"></audio-play-area>
                  <!-- 音频标注区 -->
                  <audio-annotation-testModelArea
                    v-if="modelType == 6"
                    :annotationsList="uploadFilePreview"
                    :regionAudio="preview"
                    ref="audioLabelRegion"
                  ></audio-annotation-testModelArea>
                </div>
              </div>
            </div>
          </div>
          <div class="btns">
            <el-button type="primary" class="btn-primary" @click="verifyStart"
              >开始校验</el-button
            >
          </div>
        </div>
        <div class="verify-result">
          <div class="title">校验结果：</div>
          <!-- 校验结果：图像分类/文本分类/文本标注/音频分类 -->
          <div class="result-tb" v-if="modelType == 1 || modelType == 3 || modelType == 4 || modelType == 5">
            <div class="thead-div">
              <span>索引</span>
              <span>预测分类</span>
              <span>置信度</span>
            </div>
            <div class="tbody-div">
              <div class="not-result" v-if="!verifyResult || verifyResult.length <= 0">
                <icon-base v-bind="Icons.notResult">
                  <icon-not-result />
                </icon-base>
                <span>{{resultTips ? '未识别到目标对象！':'暂无校验结果！'}}</span>
              </div>
              <div class="result-tr" v-for="(item, idx) in verifyResult" :key="idx">
                <span>{{ idx + 1 }}</span>
                <span :title="item[0] ? item[0].labelName : item.labelName">
                  {{ item[0] ? item[0].labelName : item.labelName || "未检测到物体" }}
                </span>
                <span>
                  {{ item[0] ? item[0].confidence : item.confidence | confidence }}
                </span>
              </div>
            </div>
          </div>
          <!-- 校验结果：物体检测 -->
          <div class="result-tb table" v-if="modelType == 2">
            <div class="tr-labelTag-checkbox">
              <div class="nav-tr" v-for="item in navCheckList" :key="item">
                <span><i @click="onSelectNavTagState(item)">{{item}}</i></span>
              </div>
            </div>
            <div class="thead-div">
              <span>索引</span>
              <span>预测分类</span>
              <span>置信度</span>
            </div>
            <div class="tbody-div">
              <div class="not-result" v-if="!verifyResultImg[preview.index] || verifyResultImg[preview.index].length <= 0">
                <icon-base v-bind="Icons.notResult">
                  <icon-not-result />
                </icon-base>
                <span>{{resultTips ? '未识别到目标对象！':'暂无校验结果！'}}</span>
              </div>
              <div v-for="(item, idx) in verifyResultImg[preview.index]" :key="idx">
                <div class="result-tr list-tr" v-if="item.labelTagState">
                  <span class="td-text-left">
                    <i :class="[item.isShow ? 'el-icon-check i-select' : '']" :style="{'background':item.isShow?item.labelColor:'#fff',   'border-color':item.labelColor}" @click.stop="onSelectLabelTag(item.labelTagId)"></i>
                    {{ idx + 1 }}
                  </span>
                  <span :title="item[0] ? item[0].labelName : item.labelName">
                    {{ item[0] ? item[0].labelName : item.labelName || "未检测到物体" }}
                  </span>
                  <span>
                    {{ item[0] ? item[0].confidence : item.confidence | confidence }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- 校验结果：音频标注 -->
          <div class="result-tb" v-if="modelType == 6">
            <div class="thead-div">
              <span>索引</span>
              <span>预测分类</span>
              <span>置信度</span>
            </div>
            <div class="tbody-div">
              <div class="not-result" v-if="!verifyResultAudio[preview.index] || verifyResultAudio[preview.index].length <= 0">
                <icon-base v-bind="Icons.notResult">
                  <icon-not-result />
                </icon-base>
                <span>{{resultTips ? '未识别到目标对象！':'暂无校验结果！'}}</span>
              </div>
              <div class="result-tr" v-for="(item, idx) in verifyResultAudio[preview.index]" :key="idx">
                <span>{{ idx + 1 }}</span>
                <span :title="item[0] ? item[0].labelName : item.labelName">
                  {{ item[0] ? item[0].labelName : item.labelName || "未检测到物体" }}
                </span>
                <span>
                  {{ item[0] ? item[0].confidence : item.confidence | confidence }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- 校验模型流程 -->
        <verification-model-process v-if="!verificationNoTips && verificationModelProcessShow" :modelType="modelType" @toVerificationModelPage="toVerificationModelPage"></verification-model-process>
      </div>

      <!-- 发布模型 release -->
      <div class="release" v-if="operate === 'release'">
        <div class="intxt">
          <label class="label" for>
            <i class="required">*</i>选择发布模型：
          </label>
          <el-select
            class="select-box"
            v-model="activeModel"
            placeholder="请选择发布模型"
            filterable
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="intxt select-box">
          <label class="label" for>
            <i class="required">*</i>选择模型版本：
          </label>
          <el-select
            class="select-box"
            v-model="activeTrainingModel"
            placeholder="请选择模型版本"
            ref="verify-Model"
            filterable
          >
            <el-option
              v-for="item in versionOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="common-module" v-if="userRole == 4">
          <span>公开模型：</span>
          <el-switch
            v-model="commonModuleValue"
            active-color="#4c88ff"
            inactive-color="#C0C4CC">
          </el-switch>
        </div>
        <div class="btns">
          <el-button type="primary" class="btn-primary" @click="releaseModel"
            >发布模型</el-button
          >
        </div>
      </div>
    </div>

    <!-- 弹窗集 -->
    <div class="popup-list">
      <!-- 校验结果 -->
      <gat-popup
        :class="['verify-report', popupActive === 'verify_report' ? 'on' : 'off']"
        :title="'校验结果'"
        @cancel="cancelPopup"
        @confirm="cancelPopup"
      >
        <template v-slot:content>
          <div class="report-cnt">
            <div class="loading" v-show="popupData.verify.status === 'loading'">
              模型校验正在进行…
            </div>

            <div class="error" v-show="popupData.verify.status === 'error'">
              模型校验出错，请再次尝试
            </div>
          </div>
        </template>
      </gat-popup>
      <!-- 上传图片提示 -->
      <gat-popup
        :class="['popup-upload-tip', popupActive === 'uploadtip' ? 'on' : 'off']"
        :title="`${modelTypeCompany(modelType)}上传说明`"
        @cancel="cancelPopup"
      >
        <template v-slot:content>
          <ul class="tips">
            <li class="tip-list" v-if="modelType==1 || modelType==2">
              <i class="required">*</i>支持图片格式为：jpg/jpeg，大小限制在<b> 4MB </b>以内；
            </li>
            <li class="tip-list" v-if="modelType==1 || modelType==2">
              <i class="required">*</i>图片最大为<b> 2048px*2048px </b
              >，最小为<b> 64px*64px </b>；
            </li>
            <li class="tip-list" v-if="modelType==3 || modelType==4">
              <i class="required">*</i>支持TXT格式文本，大小限制在<b> 500KB </b>以内；
            </li>
            <li class="tip-list" v-if="modelType==5 || modelType==6">
              <i class="required">*</i>支持WAV、MP3格式音频，大小限制在<b> 5MB </b>以内；
            </li>
            <li class="tip-list">
              <i class="required">*</i>校验{{modelTypeCompany(modelType)}}上传最多不超过<b> 10 {{modelType==1||modelType==2?'张':'个'}} </b>；
            </li>
            <li class="tip-list" v-if="modelType==1 || modelType==2">
              <i class="required">*</i>建议上传图片宽度比<b> 5:3 </b>；
            </li>
          </ul>
          <!-- TODO:警告不完备 -->
          <span class="contact">若上传失败，请检查网络设置</span>
          <el-checkbox
            class="check-box"
            v-model="popupData.uploadNoTip"
            @change="uploadNoTipChange"
            >下次不再提示</el-checkbox
          >
        </template>
        <template v-slot:buttons>
          <el-button class="primary" @click="confirmUploadTip"
            >我知道了</el-button
          >
        </template>
      </gat-popup>

      <!-- 训练配置 -->
      <TrainingConfigurationPopup
        :modelType="modelType"
        :popupActive="popupActive"
        :labelNum="labelNum"
        :modelId="activeModel"
        :datasetId="activeDataset"
        :labelIds="labelIds"
        :labelNames="labelNames"
        @confirmConfiguration="confirmConfiguration"
        @cancelPopup="cancelPopup"
      ></TrainingConfigurationPopup>
    </div>
  </div>
</template>

<script>
import PRETRAIN from "@/axios/pretrain/pretrain.js";
import COMMON from "@/axios/common/common.js";
import GatPopup from "@/components/common/GatPopup";
// import ColumnsSlider from "@/components/common/ColumnsSlider";
import ColumnsSlider from "@/components/pretrain/ImgSlider";
import TxtSlider from '@/components/pretrain/TxtSlider'
import AudioSlider from '@/components/pretrain/AudioSlider'
import IconTrashCan from "@/components/icons/typography/TrashCan";
import IconNotResult from "@/components/icons/typography/NotResult";
import TrainingModelProcess from "@/components/pretrain/TrainingModelProcess";
import VerificationModelProcess from "@/components/pretrain/VerificationModelProcess";

import AudioAnnotationTestModelArea from '@/components/pretrain/AudioAnnotationTestModelArea'
import AudioPlayArea from '@/components/pretrain/AudioPlayArea'
import LabelRegionTestModel from '@/components/pretrain/LabelRegionTestModel'

import TrainingConfigurationPopup from '@/components/pretrain/TrainingConfigurationPopup'

import { debounce } from 'lodash' // 引入lodash数组函数方法
import { GetText } from '@/assets/js/mixin/mixinGetTextStr.js' // 解析txt文件
import { GetVerifyImgs } from '@/assets/js/mixin/mixinGetVerifyImgs.js'

export default {
  components: { 
    GatPopup,
    ColumnsSlider,
    IconTrashCan,
    IconNotResult,
    TrainingModelProcess,
    VerificationModelProcess,
    TxtSlider,
    AudioSlider,
    AudioAnnotationTestModelArea,
    AudioPlayArea,
    LabelRegionTestModel,
    TrainingConfigurationPopup,
  },
  mixins: [GetText, GetVerifyImgs],
  props: {
    operate: {
      type: String,
      default: "create"
    }
  },
  filters: {
    confidence(val) {
      if (!val) {
        return;
      }
      return val > 0 ? parseFloat((Number(val) * 100).toFixed(2)) + "%" : "--";
    }
  },
  data() {
    return {
      userRole: 2, // 角色： 2-学生、1-老师、3-校管理员、4-超级管理员
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 资源平台上传基地址（代理）
      fileBaseUrl: window.gtaAiConfig.fileBaseUrl, // 资源平台上传基地址
      navCheckList: ['全选', '全不选', '反选'],
      currentNavlabel: '全选',
      labelList: [],
      labelColorList: ['#ff3399', '#cc0000', '#ff9900', '#ffff33', '#009900', '#0099cc', '#9933ff', '#336666', '#33ffff', '#3300ff', '#cc99cc', '#999999', '#ffcc99', '#660000', '#249662'],
      trainingNoTips: false, // 训练模型流程是否不再提示
      trainingModelProcessShow: false, // 训练模型流程模块是否显示
      verificationNoTips: false, // 检验模型流程是否不再提示
      verificationModelProcessShow: false, // 检验模型流程模块是否显示
      // 创建模型
      Create: {
        modelName: "",
        modelFuncDesc: ""
      },
      // 训练模型
      Training: {
        tags: []
      },
      // 校验模型
      Verify: {
        value: ""
      },
      // 模型数据
      Model: {
        // records: [],
        records: null,
        current: 1,
        size: 999,
        total: 0
      },
      // 训练模型列表 #暂时没用上
      VerifyModel: [],
      // 模型数据集
      Dataset: {
        // records: [],
        records: null,
        PageIndex: 1,
        PageSize: 999,
        total: 0
      },
      //数据集版本
      versionList: [],
      datasetName:'',
      // 模型标签
      Label: {
        records: null,
        PageIndex: 1,
        PageSize: 999,
        total: 0
      },
      TrainingModel: [],
      selectVersion:"",
      activeModel: "", // 激活的模型
      versionOptions:[],
      versionOptions2:[],
      activeDataset: "", // 激活的数据集
      activeTrainingModel: "", // 模型版本号
      uploadFile: [], // 文件上传列表
      uploadFilePreview: [], // 上传文件预览
      preview: { imgUrl: "", index: 0, imgPos: {}, labelList: [], textName: "", textId: "", audioName: "", audioId: "" },
      textPreview: "", // 解析文本
      popupActive: "", // 弹窗
      popupData: {
        verify: {
          status: "",
          result: []
        },
        uploadNoTip: false,
      },
      durationList: [], // 音频列表总时长列表
      currentAudioUrl: '', // 当前音频路径
      // 当前音频
      currentAudio: {
        index: 0,
        audioUrl: '',
      },
      // 页面标题
      pageTitle: {
        create: {
          label: "创建模型",
          viewProcess: ''
        },
        training: {
          label: "训练模型",
          viewProcess: '查看原理流程'
        },
        verify: {
          label: "校验模型",
          viewProcess: '查看原理流程'
        },
        release: {
          label: "发布模型",
          viewProcess: ''
        }
      },
      // 错误次数
      errorCount: 0,
      Icons: {
        trashCan: {
          iconName: "删除",
          viewBox: "0 0 23 24",
          width: "23",
          height: "24"
        },
        notResult: {
          icoName: "",
          viewBox: "0 0 28 33",
          width: "28",
          height: "33"
        }
      },
      unfinished: false,
      unfinishedLabl: "",
      commonModuleValue: false,
      resultTips: false,
      labelNum: 0, // 选中标签集数量
      labelIds: [], // 选中标签id集
      labelNames: [], // 选中标签名称集
      trainModelConfigReq: {}, // 自定义训练配置参数
      formdata: new FormData(),
      fullscreenLoading: null, // 加载效果
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    // 模型
    options() {
      if (!this.Model.records) {
        return [];
      }
      return this.Model.records.map(model => {
        return {
          value: model.modelId,
          label: model.modelName
        };
      });
    },
    // 数据集
    dataSetOptions() {
      if (!this.Dataset.records) {
        return [];
      }

      return this.Dataset.records.map(dataset => {
        return {
          value: dataset.datasetName,
          label: dataset.datasetName
        };
      });
    },
    // 版本信息，从训练模型数据库获取 trainingModel
    // versionOptions() {
    //   var options = [];
    //
    //   if (!this.TrainingModel) {
    //     return;
    //   }
    //
    //   options = this.TrainingModel.map(item => {
    //     return {
    //       value: item.trainModelId,
    //       label: item.version
    //     };
    //   });
    //   return options;
    // },

    modelType() {
      return this.$route.params.modeltype;
    },
    isMoreThan() {
      var val = true,
        limit = 0,
        modelType = this.modelType;

      if (modelType === "1" || modelType === "3" || modelType === "4" || modelType === "5" || modelType === "6") {
        limit = 2;
      } else if (modelType === "2") {
        limit = 1;
      }

      val = this.Training.tags.length < limit;

      return { limit: limit, val: val };
    },
    // 校验结果
    verifyResult:{
      get() {
        return this.popupData.verify.result;
      },
      set(v) {}
    },
    // 校验结果：物体检测
    verifyResultImg:{
      get(){
        let labelColorList = this.labelColorList; // 颜色列表
        let imgList = this.popupData.verify.result; // 图片校验返回结果列表
        if (imgList && imgList.length) {
          imgList.forEach((item, index) => {
            let labelList = []; // 标签列表
            item.forEach((itn, idx) => {
              let timesId = new Date().getTime().toString() + idx;
              let flng = false;
              flng = labelList.every(i => {
                return i.labelName !== itn.labelName;
              });
              if (flng) {
                let num = labelList.length;
                // 获取返回结果的所有标签名
                labelList.push({
                  labelName: itn.labelName, // 标签名
                  labelColor: labelColorList[num], // 标签颜色
                  labelState: true, // 标签状态
                });
              }
  
              labelList.forEach(i => {
                if (i.labelName === itn.labelName) {
                  itn.labelColor = i.labelColor; // 标注颜色
                }
              });
  
              itn.labelTagId = timesId; // 标注id
              itn.labelTagState = true; // 控制标注显示隐藏状态
              itn.isShow = true; // 控制标注显示隐藏状态
            });
            item.labelList = labelList; // 当前图片标签列表
          });
        } else {
          setTimeout(() => {
            this.$refs.imgLabelRegion.updateTagImg([]); // 调用方法更新图片标注
          }, 100);
        }
        return imgList;
      },
      set (v) {}
    },
    // 校验结果：音频标注
    verifyResultAudio:{
      get() {
        return this.popupData.verify.result;
      },
      set(v) {}
    },
  },
  watch: {
    token() {
      this.getModelList();
      this.getDatasetPageList();
    },
     activeTrainingModel(val){
      this.preview.imgUrl = "";
      this.uploadFilePreview = [];
      this.uploadFile = [];
      this.popupData.verify.result = [];
      this.currentAudioUrl = "";
      this.textPreview = ""; 
      this.datasetName =''
    },
    datasetName(val){
      this.activeDataset = ''
      this.getVersionList(val)
    },
    activeDataset() {
      this.getLabelList();
      this.Training.tags = [];
      this.unfinished = false;
    },
    activeModel(activeModel) {
      // 验证
      if (this.operate === "verify" || this.operate === "release") {
        // 初始化模型版本
        if (!this.$route.query.modelId || this.$route.query.modelId != activeModel) {
          this.activeTrainingModel = "";
        }

        this.getTrainingModelList();

        // 初始化图片
        this.revokeObjectURL();
        this.uploadFile = [];
        this.popupData.verify.result = [];
      }
    },
    Model(model, oldModel) {
      // 如果上次 Model 没有 items,那么要重新获取训练版本
      
      if (!oldModel.Itmes && this.activeModel) {
        this.getTrainingModelList();
      }
    },
    // 混入方式获取解析的文本
    getTextStr(val) {
      if (val) {
        this.textPreview = val;
      }
    },
    uploadFilePreview(val) {
      if (val.length === 0) {
        this.resultTips = false;
      }
    },
  },
  created() {
    // 获取用户身份（老师/学生/管理员）
    this.userRole = this.$store.state.userRole;

    this.getUploadNoTipState(); // 获取上传提示弹窗状态
  },
  mounted() {
    if (this.token) {
      this.getModelList(); //模型列表
      this.getVerifyModel(); // 校验模型列表
      this.getDatasetPageList();
    }
    if (this.$route.query.modelId) {
      this.activeModel = this.$route.query.modelId;
    }
    // console.log("this.$route.params", this.$route.params);
    if (this.$route.params.version) {
      let version = this.$route.params.version;
      this.selectVersion = version;
      this.activeTrainingModel = version;
    }
  },
  beforeDestory() {
    // 预览图片回收
    this.revokeObjectURL();
  },
  methods: {
    // 上一页
    sliderPrev(direct) {
      if (this.uploadFilePreview.length > 5) {
        let flang = true;
        this.uploadFilePreview.forEach((item, index) => {
          if (index < 5 && item.imgId === this.preview.imgId) {
            flang = false;
          }
        });
        if (flang) {
          let image = this.uploadFilePreview[0];
          this.activePreview(image);
        }
      }
    },
    // 下一页
    sliderNext(direct) {
      if (this.uploadFilePreview.length > 5) {
        let flang = true;
        this.uploadFilePreview.forEach((item, index) => {
          if (index >= 5 && item.imgId === this.preview.imgId) {
            flang = false;
          }
        });
        if (flang) {
          let image = this.uploadFilePreview[5];
          this.activePreview(image);
        }
      }
    },
    // 模型类别单位过滤
    modelTypeCompany(type) {
      if (type == 1 || type == 2) {
        return '图片';
      } else if (type == 3 || type == 4) {
        return '文本';
      } else if (type == 5 || type == 6) {
        return '音频';
      }
    },
    // 训练模型提示语
    trainingRuleTips(type) {
      if (type == 1 || type == 3 || type == 5) {
        return `标签下的${this.modelTypeCompany(type)}不足20${type == 1 ? '张':'个'}，请补充其数量~`;
      } else if (type == 4 || type == 6) {
        return `标签下的${type == 4 ? '文本标注':'音频片段'}不足20个，请补充其数量~`;
      } else if (type == 2) {
        return '标签下的图片不足40张，请补充其数量~';
      }
    },
    // 物体检测：标签全选、全不选、反选
    onSelectNavState(navName) {
      this.currentNavlabel = navName;
      if (navName === '全选') {
        this.onSelectLabel(navName);
      } else if (navName === '全不选') {
        this.onSelectLabel(navName);
      } else { // 反选
        this.onSelectLabel(navName);
      }
      this.$forceUpdate(); // 强制更新数据
    },
    /* 物体检测：图片标签下所有标注显示隐藏 
     * labelState:true标签打钩
     * labelTagState：true右侧标注结果打钩
     * isShow：true图片上的标注显示
    */
    onSelectLabel (labelName) {
      let index = this.preview.index;
      if (this.verifyResultImg && this.verifyResultImg[index]) {
        // 标签列表
        this.verifyResultImg[index].labelList.forEach(item => {
          if (item.labelName === labelName) { // 判断点击了标签
            item.labelState = !item.labelState;
          }
  
          if (labelName === '全选') { 
            item.labelState = true;
          } else if (labelName === '全不选') {
            item.labelState = false;
          } else if (labelName === '反选') {
            item.labelState = !item.labelState;
          }
        });

        this.verifyResultImg[index].forEach(item => {
          if (item.labelName === labelName) { // 判断点击了标签
            item.labelTagState = !item.labelTagState;
            item.isShow = item.labelTagState;
          }
          if (labelName === '全选') {
            item.labelTagState = true;
            item.isShow = true;
          } else if (labelName === '全不选') {
            item.labelTagState = false;
            item.isShow = false;
          } else if (labelName === '反选') {
            item.labelTagState = !item.labelTagState;
            item.isShow = item.labelTagState;
          }
        });
        this.$refs.imgLabelRegion.updateTagImg(this.verifyResultImg[index]); // 调用方法更新图片标注
        this.$forceUpdate(); // 强制更新数据
      }
    },
    // 物体检测：标注全选、全不选、反选
    onSelectNavTagState(navName) {
      let index = this.preview.index;
      let labelList = this.verifyResultImg[index].labelList;
      if (this.verifyResultImg && this.verifyResultImg[index]) {
        this.verifyResultImg[index].forEach(item => {
          labelList.forEach(itm => {
            if (itm.labelState && itm.labelName === item.labelName) {
              if (navName === '全选') {
                item.isShow = true;
              } else if (navName === '全不选') {
                item.isShow = false;
              } else if (navName === '反选') {
                item.isShow = !item.isShow;
              }
            }
          });
        });
        this.$refs.imgLabelRegion.updateTagImg(this.verifyResultImg[index]); // 调用方法更新图片标注
        this.$forceUpdate(); // 强制更新数据
      }
    },
    // 物体检测：图片标注显示隐藏
    onSelectLabelTag (labelTagId) {
      let index = this.preview.index;
      this.verifyResultImg[index].forEach(item => {
        if (item.labelTagId === labelTagId) {
          item.isShow = !item.isShow;
        }
      });
      this.$refs.imgLabelRegion.updateTagImg(this.verifyResultImg[index]); // 调用方法更新图片标注
      this.$forceUpdate(); // 强制更新数据
    },

    // 创建模型
    createModel() {
      var modeltype = this.$route.params.modeltype,
        data = {
          type: modeltype
        };
      // TODO: 必填项未填写提示
      if (!(this.Create.modelName && this.Create.modelFuncDesc)) {
        return this.$message.error("请完整填写模型相关内容");
      }

      data.modelName = this.Create.modelName;
      data.modelFuncDesc = this.Create.modelFuncDesc;
      PRETRAIN.addModel(data).then(result => {
        if (result.isSuccess) {
          this.$message.success(result.returnMsg);
          this.$router.push({
            name: "model-list",
            params: { modeltype: modeltype }
          });
        } else {
          this.$message.error(result.returnMsg);
        }
      });
    },
    // 取消创建
    createModelCancel() {
      var route = this.$route;
      this.$router.push({
        name: "model-list",
        params: { modeltype: route.params.modeltype }
      });
    },
    // 获取模型数据
    getModelList(pageIndex, key) {
      var pageIndex_ = pageIndex ? pageIndex : this.Model.current,
        pageSize = this.Model.size,
        modeltype = this.$route.params.modeltype,
        modelName = "",
        data = {
          modelName: modelName,
          type: modeltype,
          pageNum: pageIndex_,
          pageSize: pageSize
        };

      if (key) {
        data.modelName = key;
      }
      PRETRAIN.getMyModelList(data).then(result => {
        if (result.isSuccess || result.returnCode == 200) {
          if (result.data.records) {
            this.Model = result.data;
          }
        }
      });
    },
    // 查询训练模型下拉框
    getVerifyModel(pageIndex, key) {
      var pageIndex_ = pageIndex ? pageIndex : this.Model.current,
        pageSize = this.Model.size,
        modeltype = this.$route.params.modeltype,
        modelName = "",
        data = {
          modelName: modelName,
          type: modeltype,
          pageNum: pageIndex_,
          pageSize: pageSize
        };

      if (key) {
        data.modelName = key;
      }
      PRETRAIN.getVerifyModel(data).then(result => {
        if (result.isSuccess || result.returnCode == 200) {
          this.VerifyModel = result.data;
        }
      });
    },

    // 获取模型数据集 --改为查询模型数据下拉框
    // TODO:后续可以做滚动加载，但是对选项搜索可能不友好
    getDatasetPageList(pageIndex) {
      var pageIndex_ = pageIndex ? pageIndex : this.Dataset.pageIndex,
        pageSize = this.Dataset.current,
        modelType = this.modelType,
        key = this.key,
        data = {
          type: modelType,
          pageIndex: pageIndex_,
          pageNum: pageSize
        };

      if (key) {
        data.datasetName = key;
      }
      return new Promise((resolve, reject) => {
        PRETRAIN.selectDataset(data).then(result => {
          if (result.isSuccess) {
            if (result.data) {
              this.Dataset.records = result.data;
            }
            resolve(result.data);
          } else {
            reject(result);
          }
        });
      });
    },
      // 获取已发布的数据集版本列表
    getVersionList(datasetName) {
      let data = {
        type: this.modelType,
        datasetName,
      }
      return new Promise((resolve, reject) => {
        PRETRAIN.selectDatasetReleaseVersion(data).then((result) => {
          if (result.isSuccess) {
            this.versionList = result.data
          
            resolve(result.data)
          } else {
            reject(result)
          }
        })
      })
    },
    /**
     * 根据数据集id查询标签  @data  "datasetId"数据集id
     */
    // 标签处理，标签最多 20 个，图片分类至少 2 个，图片检测至少 1 个
    getLabelList() {
      var datasetId = this.activeDataset,
        modelType = this.modelType,
        data = {
          datasetId: datasetId,
          modelType: modelType
        };

      return new Promise((resolve, reject) => {
        PRETRAIN.getLabelNumByDatasetId(data).then(result => {
          if (result.isSuccess) {
            this.Label.records = result.data; // records的处理;
            // this.Label = result.data;
            if (result.data.length > 0) {
              this.activeLabel = result.data[0].labelId;
            }
            resolve(result.data);
          } else {
            reject(result);
          }
        });
      });
    },
    // 获取训练模型数据，即版本数据
    getTrainingModelList() {
      var modelId = this.activeModel,
        model,
        datasetId,
        type,
        data = {};

      if (!this.Model.records) {
        return;
      }

      model = this.Model.records.find(item => item.modelId === modelId);
      datasetId = model.datasetId;
      type = model.type;
      // 训练模型状态要训练完成以上才能用
      data = {
        modelId: modelId,
        datasetId: datasetId
        // PageSize: 999 // TODO:后续滚动加载
      };

      PRETRAIN.getModelVersion(data).then(result => {
        if (result.isSuccess) {
          this.TrainingModel = result.data;
          this.getVersionOptions(result.data);
        }
      });
    },
    getVersionOptions() {
      var options = [];

      if (!this.TrainingModel) {
        return;
      }

      options = this.TrainingModel.map(item => {
        return {
          value: item.algorithmId,
          // value: item.trainModelId,
          label: item.version
        };
      });
      this.versionOptions =JSON.parse(JSON.stringify(options));
      this.versionOptions2 =JSON.parse(JSON.stringify(options));
    },
    // 打开训练配置弹窗
    onClickConfiguration() {
      if (!this.activeModel || !this.activeDataset || this.Training.tags.length < this.isMoreThan.limit) {
        return;
      }
      if (this.unfinished) {
        return;
      }
      
      this.popupActive = 'training_configuration';
    },
    toTrainingModelPage() {
      this.trainingModelProcessShow = false;
    },
    onClickSee(label) {
      if (label === '训练模型') {
        this.trainingModelProcessShow = true; // 弹出训练模型流程
      } else {
        this.verificationModelProcessShow = true; // 弹出训练模型流程
      }
    },
    // 开始训练
    // operate=training
    trainingStart() {
      if (!this.activeModel || !this.activeDataset || this.Training.tags.length < this.isMoreThan.limit) {
        return;
      }
      if (this.operate !== "training" || this.unfinished) {
        return;
      }
      let trainingNoTips = false;
      if (this.modelType == 1) {
        trainingNoTips = window.localStorage.getItem('__training_noTips_one__');
      } else if (this.modelType == 2) {
        trainingNoTips = window.localStorage.getItem('__training_noTips_two__');
      } else if (this.modelType == 3) {
        trainingNoTips = window.localStorage.getItem('__training_noTips_three__');
      } else if (this.modelType == 4) {
        trainingNoTips = window.localStorage.getItem('__training_noTips_four__');
      } else if (this.modelType == 5) {
        trainingNoTips = window.localStorage.getItem('__training_noTips_five__');
      } else if (this.modelType == 6) {
        trainingNoTips = window.localStorage.getItem('__training_noTips_six__');
      }
      this.trainingNoTips = trainingNoTips ? trainingNoTips : false;
      // if (this.trainingNoTips) {
      //   // 直接开始训练
      //   this.toStartTraining()
      // } else {
      //   // 弹出训练模型流程
      //   this.trainingModelProcessShow = true
      // }
      this.toStartTraining(); // 开始训练
    },
    // 浏览训练模型流程后开始训练模型
    // startTraining() {
      // this.toStartTraining() // 开始训练
    // },
    // 训练模型：防抖
    toStartTraining:debounce(function(type) {
      var modelType = this.modelType,
        modelId = this.activeModel,
        datasetId = this.activeDataset,
        labelIds = this.Training.tags,
        labelIdList = [],
        labelNames = [],
        data = {};

      // if (this.operate !== "training" || this.unfinished) {
      //   return;
      // }

      this.Label.records.forEach(item => {
        labelIds.forEach(i => {
          if (i == item.labelId) {
            labelIdList.push(item.labelId);
            labelNames.push(item.labelName);
          }
        });
      });
        
      // @data datasetId  labelIds labelNames modelId modelType
      data = {
        modelType: modelType,
        modelId: modelId,
        datasetId: datasetId,
        // labelIds: labelIds.join(","),
        labelIds: labelIdList.join(","),
        labelNames: labelNames.join(","),
        trainModelConfigReq: this.trainModelConfigReq, // 自定义训练配置参数
      };

      PRETRAIN.addTrainModel(data).then(result => {
        if (result.isSuccess) {
          this.$message.success(result.returnMsg);
          this.$router.push({
            name: "model-list",
            params: { modeltype: this.modelType },
            query: { display: "version", modelId: modelId }
          });
          this.getModelPageIndex(); // 通过当前模型id获取“我的模型”页码
          this.trainingModelProcessShow = false;
        } else {
          this.trainingModelProcessShow = false;
          this.$message.error(result.returnMsg);
        }
      }).catch(err => {
        this.trainingModelProcessShow = false;
        console.log('error', err);
      });
    }, 500),

    // 通过当前模型id获取“我的模型”页码
    getModelPageIndex() {
      this.options.forEach((item, index) => {
        if (item.value === this.activeModel) {
          localStorage.modelPageIndex = Math.ceil((index + 1) / 10); // 缓存到localStorage ，跳转我的模型获取
        }
      });
    },

    // 图片上传说明
    activeUploadTipPopup() {
      this.popupActive = 'uploadtip';
    },
    // 上传提示显示后再进行上传操作
    confirmUploadTip() {
      this.cancelPopup(); // 关闭弹窗
      // TODO:上传图片事件触发
      this.uploadPicturesToDataset();
    },
    // 上传图片
    uploadNoTipChange(val) {
      this.localStorageUploadTip('save', val);
    },
    // 图片上传说明是否显示存储
    localStorageUploadTip(type, value) {
      if (type === 'save') {
        this.popupData.uploadNoTip = value;
        window.localStorage.setItem(`__uploadVerify_tip_type${this.modelType}__`, value);
      } else {
        // let uploadNoTip = window.localStorage.getItem('__uploadVerify_tip__')
        // this.popupData.uploadNoTip = uploadNoTip ? uploadNoTip : false
        this.getUploadNoTipState(); // 获取上传提示弹窗状态
      }
    },
    // 获取上传提示弹窗状态
    getUploadNoTipState() {
      let uploadNoTip = window.localStorage.getItem(`__uploadVerify_tip_type${this.modelType}__`);
      this.popupData.uploadNoTip = uploadNoTip ? uploadNoTip : false;
    },

    // 上传校验图片/文本/音频
    uploadForVerify() {
      if (this.uploadFilePreview.length >= 10) {
        return this.$message.error('总数不超过10个哦~');
      }
      // TODO: 数据集选定、分类标签选定
      if (!this.popupData.uploadNoTip) {
        this.activeUploadTipPopup();
      } else {
        // 直接上传
        this.uploadPicturesToDataset();
      }
    },
    // 上传图片/文本/音频
    uploadPicturesToDataset() {
      let uploadFileNode = document.createElement("input"), // 创建上传按钮
        self = this;

      uploadFileNode.setAttribute("type", "file"); // 设置上传按钮属性
      uploadFileNode.setAttribute("multiple", "ture"); // 多文件上传
      if (self.modelType == 1 || self.modelType == 2) {
        uploadFileNode.setAttribute("accept", "image/jpeg,image/jpg"); // 限制图片上传
        // uploadFileNode.setAttribute("accept", "image/*"); // 限制图片除外的文件上传
      }
      if (self.modelType == 3 || self.modelType == 4) {
        uploadFileNode.setAttribute("accept", ".txt"); // 限制txt除外的文件上传
      }
      if (self.modelType == 5 || self.modelType == 6) {
        uploadFileNode.setAttribute("accept", ".mp3, .wav"); // 限制mp3/wav除外的文件上传
      }

      uploadFileNode.click(); // 触发上传事件

      // 上传进程，上传成功应要移除监听程序
      uploadFileNode.onchange = function uploadChange(evt) {
        let formdata = new FormData(), 
          files = evt.target.files,
          previewList = self.uploadFilePreview,
          uploadFile = self.uploadFile,
          list,
          formatPass = true;

        list = Array.from(files);

        // 上传加载效果
        self.fullscreenLoading = self.$loading({
          lock: true,
          text: '上传中请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        let noFile = 0;

        // 图片分类，物体检测
        if (self.modelType == 1 || self.modelType == 2) {
          if (list.length + previewList.length > 10) {
            self.fullscreenLoading.close(); // 关闭Loading
            return self.$message.error('上传失败，图片上传总数最多不超过10个哦~');
          }
  
          self.noFile = 0;
          list.forEach((item, index) => {
            // self.selectUploadPicSize(item, list, index);
            let typeFlag = self.$util.filesFormatCheck(item, "jpg|jpeg"); // 检验文件类型
            if (typeFlag) {
              self.noFile++
              self.$message.error(`${item.name}上传失败，只允许上传 jpg/jpeg 格式图片！`);
            } else {
              formdata.append('file', item);
            }
          });
  
          if (list.length === self.noFile) {
            return self.fullscreenLoading.close(); // 关闭Loading
          }

          self.UploadMultipleFileApi(formdata); // 上传图片接口调用
          uploadFileNode = null; // 获取上传信息后移除上传元素
        }

        // 文本分类，文本标注
        if (self.modelType == 3 || self.modelType == 4) {
          if (list.length + previewList.length > 10) {
            self.fullscreenLoading.close(); // 关闭Loading
            return self.$message.error('上传失败，文本上传总数最多不超过10个哦~');
          }
  
          list.forEach(async (file) => {
            let typeFlag = self.$util.filesFormatCheck(file, 'txt');
            if (typeFlag) {
              noFile++;
              self.$message.error(`${file.name}上传失败，请上传格式为txt的文件！`);
            } else if (file.size > 500 * 1024) {
              noFile++;
              self.$message.error(`上传失败，文件名称为${file.name}格式过大！`);
            } else {
              formdata.append('file', file);
              // self.popupData.verify.result = [];
            }
          })
          if (list.length === noFile) {
            return self.fullscreenLoading.close(); // 关闭Loading
          }

          setTimeout(() => {
            COMMON.UploadMultipleFile(formdata).then((result) => {
              if (result.returnCode === 200) {
                let data = result.data;
                data.forEach(item => {
                  self.uploadFilePreview.splice(previewList.length, 1, {
                    imgId: item.id,
                    imgUrl: self.photoBaseUrl + item.url,
                    textName: item.fileName,
                    textId: item.id,
                  });
                });

                let filePath = self.photoBaseUrl + result.data[0].url;
                //混入函数
                this.getTxtContent(filePath); // 解析文本
                self.fullscreenLoading.close(); // 关闭Loading

                self.uploadFile = result.data.map(item => {
                  return {url: self.photoBaseUrl + item.url};
                });
              } else {
                self.$message.error(result.returnMsg);
                self.fullscreenLoading.close(); // 关闭Loading
              }
            }).catch((error)=>{
              console.log('error', error);
              self.fullscreenLoading.close(); // 关闭Loading
            });
          }, 100)
        }

        // 音频分类，音频标注
        if (self.modelType == 5 || self.modelType == 6) {
          if (list.length + previewList.length > 10) {
            self.fullscreenLoading.close(); // 关闭Loading
            return self.$message.error('上传失败，音频上传总数最多不超过10个哦~');
          }
  
          list.forEach(async (file) => {
            let typeFlag = self.$util.filesFormatCheck(file, 'mp3|MP3|wav|WAV');
            if (typeFlag) {
              noFile++;
              self.$message.error(`${file.name}上传失败，请上传格式为 wav/mp3 的音频！`);
            } else if (file.size > 5242880) {
              noFile++;
              self.$message.error(`上传失败，音频名称为${file.name}格式过大！`);
            } else {
              formdata.append('file', file);
              // self.popupData.verify.result = [];
            }
          })
          if (list.length === noFile) {
            return self.fullscreenLoading.close(); // 关闭Loading
          }

          let durationList = [];
          list.forEach(async (file) => {
            // audio获取音频总时长
            let url = URL.createObjectURL(file);
            let audioElement = new Audio(url);
            audioElement.addEventListener("loadedmetadata", function (_event) {
              durationList.push(audioElement.duration)
              // self.durationList.splice(self.durationList.length, 1, audioElement.duration)
            });
          })

          setTimeout(() => {
            COMMON.UploadMultipleFile(formdata).then((result) => {
              if (result.returnCode === 200) {
                let data = result.data;
                data.forEach((item, index) => {
                  self.uploadFilePreview.splice(previewList.length, 1, {
                    imgId: item.id,
                    imgUrl: self.photoBaseUrl + item.url,
                    audioName: item.fileName,
                    audioId: item.id,
                    audioDurationTotal: durationList[index],
                    audioList: [],
                  });
                });

                self.fullscreenLoading.close(); // 关闭Loading

                self.uploadFile = result.data.map(item => {
                  return {url: self.photoBaseUrl + item.url};
                });
              } else {
                self.$message.error(result.returnMsg);
                self.fullscreenLoading.close(); // 关闭Loading
              }
            }).catch((error)=>{
              console.log('error', error);
              self.fullscreenLoading.close(); // 关闭Loading
            });
          }, 100)
        }
      };
    },
    UploadMultipleFileApi(formdata) {
      // 获取文件上传地址
      COMMON.UploadMultipleFile(formdata).then(result => {
        if (result.returnCode === 200) {
          let dataList = JSON.parse(JSON.stringify(result.data));
          let imgList = [];
          dataList.forEach((item, index) => {
            // 检验图片格式大小尺寸区间
            if (item.size && item.size > 4194304) {
              setTimeout(() => {
                this.$message.error(`上传失败，图片名称为${item.fileName}格式过大！`);
              }, index*5);
            } else if (item.width&&item.width > 2048 || item.height&&item.height > 2048 ) {
              setTimeout(() => {
                this.$message.error(`上传失败，图片名称为“${item.fileName}”分辨率大于2048px*2048px！`);
              }, index*5);
            } else if (item.width&&item.width < 64 || item.height&&item.height < 64) {
              setTimeout(() => {
                this.$message.error( `上传失败，图片名称为“${item.fileName}”分辨率小于64px*64px！`);
              }, index*5);
            } else {
              imgList.push(item);
            }
          });

          if (imgList.length === 0) {
            return this.fullscreenLoading.close(); // 关闭Loading
          }

          // 校验图片jpg|jpeg
          this.verifyImgs(imgList).then(res => {
            if (res.correct && res.correct.length) {
              let data = {
                datasetImgList: []
              },
              previewList = this.uploadFilePreview;
  
              res.correct.forEach(i => {
                imgList.forEach(j => {
                  if (i.fileUrl.indexOf(`${j.url}`) !== -1) {
                    data.datasetImgList.push(j);
                  }
                });
              });
  
              data.datasetImgList.forEach(item => {
                this.uploadFilePreview.splice(previewList.length, 1, {
                  imgId: item.id,
                  imgUrl: this.photoBaseUrl + item.url
                });
              });
            }
          })
          this.fullscreenLoading.close(); // 关闭Loading
          // result.data.forEach(item => {
          //   this.uploadFilePreview.splice(previewList.length, 1, {
          //     imgId: item.id,
          //     imgUrl: this.photoBaseUrl + item.url
          //   });
          // });
          // this.fullscreenLoading.close(); // 关闭Loading
          // this.formdata = new FormData(); // 释放
        } else {
          this.fullscreenLoading.close(); // 关闭Loading
        }
      }).catch(err => {
        console.log('error', err)
        this.fullscreenLoading.close(); // 关闭Loading
      });
    },
    // 检验图片jpg|jpeg类型
    // verifyImgs(result) {
    //   let imgList = result.data;
    //   let params = {
    //     imgUrls: []
    //   };
    //   params.imgUrls = imgList.map((item) => {
    //     return {
    //       fileName: item.fileName, // 文件名称
    //       fileUrl: `${this.photoBaseUrl}${item.url}`, // 文件url
    //     }
    //   });
    //   COMMON.verifyImgs(params).then(res => {
    //     if (res.isSuccess) {
    //       if (res.data && res.data.correct && res.data.correct.length) {
    //         let data = {
    //             datasetImgList: []
    //           },
    //           previewList = this.uploadFilePreview;

    //         res.data.correct.forEach(i => {
    //           imgList.forEach(j => {
    //             if (i.fileUrl.indexOf(`${j.url}`) !== -1) {
    //               data.datasetImgList.push(j);
    //             }
    //           });
    //         });

    //         data.datasetImgList.forEach(item => {
    //           this.uploadFilePreview.splice(previewList.length, 1, {
    //             imgId: item.id,
    //             imgUrl: this.photoBaseUrl + item.url
    //           });
    //         });
    //         this.fullscreenLoading.close(); // 关闭Loading
    //         this.formdata = new FormData(); // 释放
    //       }
    //       if (res.data && res.data.error_info.length) {
    //         res.data.error_info.forEach((i, idx) => {
    //           setTimeout(() => {
    //             this.$message.error( `上传失败，图片名称为“${i.fileName}”只允许上传 jpg/jpeg 格式图片！`);
    //           }, idx*10);
    //         });
    //         if (imgList.length === res.data.error_info.length) {
    //           this.fullscreenLoading.close(); // 关闭Loading
    //         }
    //       }
    //     } else {
    //       this.fullscreenLoading.close(); // 关闭Loading
    //       this.$message.error('上传失败!');
    //     }
    //   }).catch((error)=>{
    //     this.fullscreenLoading.close(); // 关闭Loading
    //     this.$message.error('上传失败!');
    //   });
    // },
    toVerificationModelPage() {
      this.verificationModelProcessShow = false;
    },
    // 浏览检验模型流程后开始训练模型
    // startVerification() {
    //   this.toStartVerification()
    // },
    // 开始校验
    verifyStart() {
      if (!this.uploadFilePreview || this.uploadFilePreview.length <= 0) {
        let msg = `请上传${this.modelTypeCompany(this.modelType)}!`;
        return this.$message.warning(msg);
      }

      let verificationNoTips = false;
      if (this.modelType == 1) {
        verificationNoTips = window.localStorage.getItem('__verification_noTips_one__');
      } else if (this.modelType == 2) {
        verificationNoTips = window.localStorage.getItem('__verification_noTips_two__');
      } else if (this.modelType == 3) {
        verificationNoTips = window.localStorage.getItem('__verification_noTips_three__');
      } else if (this.modelType == 4) {
        verificationNoTips = window.localStorage.getItem('__verification_noTips_four__');
      } else if (this.modelType == 5) {
        verificationNoTips = window.localStorage.getItem('__verification_noTips_five__');
      } else if (this.modelType == 6) {
        verificationNoTips = window.localStorage.getItem('__verification_noTips_six__');
      }
      this.verificationNoTips = verificationNoTips ? verificationNoTips : false;
      // if (this.verificationNoTips) {
      //   // 直接开始校验
      //   this.toStartVerification()
      // } else {
      //   // 弹出校验模型流程
      //   this.verificationModelProcessShow = true
      // }
      this.toStartVerification();
    },
    // 校验模型：防抖
    toStartVerification:debounce(function(type) {
      if (this.modelType == 1 || this.modelType == 2) {
        this.popupData.verify.result = [];
        // let imgUrls = this.uploadFilePreview.map(item => item.imgUrl);
        let imgUrls = [];
        this.uploadFilePreview.forEach(item => {
          imgUrls.push(this.fileBaseUrl + '/aishixun' + item.imgUrl.split('/aishixun')[1]);
        });
        this.popupActive = "verify_report";
        this.popupData.verify.status = "loading";
        // 检验接口
        this.verifyModel(imgUrls);
      }

      if (this.modelType == 3 || this.modelType == 4 || this.modelType == 5) {
        // let imgUrls = this.uploadFilePreview.map(item => item.imgUrl);
        let imgUrls = [];
        this.uploadFilePreview.forEach(item => {
          imgUrls.push(this.fileBaseUrl + '/aishixun' + item.imgUrl.split('/aishixun')[1]);
        });
        this.popupActive = "verify_report";
        this.popupData.verify.status = "loading";
        // 检验接口
        this.verifyModel(imgUrls);
      }

      if (this.modelType == 6) {
        let adoList = this.$refs.audioLabelRegion.getAudioList(); // 获取音频数据列表
        let audioList = JSON.parse(JSON.stringify(adoList));
        this.popupActive = "verify_report";
        this.popupData.verify.status = "loading";
        let audioInfos = [];
        audioList.forEach(item => {
          item.audioList.forEach(i => {
            i.audioUrl = this.fileBaseUrl + '/aishixun' + i.audioUrl.split('/aishixun')[1];
          });
          audioInfos.push(item.audioList);
        });
        // 检验接口：音频标注
        this.verifyAudioTagModel(audioInfos);
      }
    }, 500),
    // 检验接口：音频标注
    verifyAudioTagModel(audioInfos) {
      let algorithmId,
        modelType,
        data = {};

      // 算法 ID : algorithmId = this.activeTrainingModel;
      algorithmId = this.TrainingModel.find(
        item => item.algorithmId === this.activeTrainingModel || item.version === this.activeTrainingModel
      ).algorithmId;

      modelType = this.modelType;
      data = {
        algorithmId,
        audioInfos: audioInfos,
        modelType
      };

      PRETRAIN.verifyAudioTagModel(data).then(res => {
        if (res.isSuccess) {
          // 显示返回的内容
          if (res.data) {
            if (Array.isArray(res.data) && res.data.length > 0) {
              this.popupData.verify.result = res.data;
            }
          }
          this.$message.success('校验成功！');
          this.resultTips = true;
          this.popupData.verify.status = "success";
          this.popupActive = "";
          this.verificationModelProcessShow = false;
        } else {
          // this.$message.error(res.returnMsg);
          this.resultTips = false;
          this.popupData.verify.status = "error";
        }
      });
    },
    // 检验接口：图片分类、物体检测、文本分类、文本标注、音频分类
    verifyModel(imgUrls) {
      let algorithmId,
        data = {};

      // 算法 ID : algorithmId = this.activeTrainingModel;
      algorithmId = this.TrainingModel.find(
        item => item.algorithmId === this.activeTrainingModel || item.version === this.activeTrainingModel
      ).algorithmId;

      data = {
        algorithmId,
        urls: imgUrls,
        modelType: this.modelType
      };

      PRETRAIN.verifyModel(data).then(res => {
        if (res.isSuccess) {
          // 显示返回的内容
          if (res.data) {
            if (Array.isArray(res.data) && res.data.length > 0) {
              this.popupData.verify.result = res.data;
            } else if (typeof res.data === "object" && res.data != null) {
              this.popupData.verify.result = [res.data];
            }
          }
          this.$message.success('校验成功！');
          this.resultTips = true;
          this.popupData.verify.status = "success";
          this.popupActive = "";
          this.verificationModelProcessShow = false;
        } else {
          // this.$message.error(res.returnMsg);
          this.resultTips = false;
          this.popupData.verify.status = "error";
        }
      });
    },
    // 激活预览
    activePreview(image, index) {
      // console.log('激活预览', image, index)
      this.preview = {
        index: index || 0,
        imgId: image.imgId || '',
        imgUrl: image.imgUrl || '',
        imgPos: image.pos || {},
        labelList: image.labelList || [],
        textId: image.imgId || '',
        textName: image.textName || '',
        audioId: image.audioId || '',
        audioName: image.audioName || '',
        audioDurationTotal: image.audioDurationTotal || 0,
        audioList: image.audioList || [],
      };
      this.currentAudioUrl = image.imgUrl || '';

      if (this.modelType == 2 && this.verifyResultImg && this.verifyResultImg[index]) { // 切换图片
        // 默认全选全部标签标注展示
        this.verifyResultImg[index].labelList.forEach(item => {
          item.labelState = true;
        });
        this.verifyResultImg[index].forEach(item => {
          item.isShow = true;
          item.labelTagState = true;
        });
        // 调用方法更新图片标注
        this.$refs.imgLabelRegion.updateTagImg(this.verifyResultImg[index]);
      }
      if (image.imgUrl && this.modelType == 3 || this.modelType == 4) {
        this.getTxtContent(image.imgUrl); // 混入函数: 解析文本
      }
    },
    // 删除文本触发
    removePreview(preview) {
      var url = preview.imgUrl,
        index = preview.index,
        modelType = this.modelType;

      // console.log(preview, index)
      if (index < 0) {
        return;
      }

      this.currentAudioUrl = '';
      this.uploadFilePreview.splice(index, 1);
      this.uploadFile.splice(index, 1);
      window.URL.revokeObjectURL(url); // 移除图片资源内存

      let idxNum = 1;
      if (index > 0 && this.uploadFilePreview.length) {
        if (this.uploadFilePreview.length > index) {
          idxNum = index;
        } else {
          idxNum = index - 1;
        }
        this.preview = this.uploadFilePreview[idxNum];
        // console.log(this.preview)
      } else if (index == 0 && this.uploadFilePreview.length) {
        this.preview = this.uploadFilePreview[index];
      } else {
        this.preview = { imgUrl: "", index: -1, imgPos: {}, labelList: [], textName: "", textId: "", audioName: "", audioId: "" };
      }
      this.preview.index = index == 0 ? index : idxNum;
      // this.preview = { imgUrl: "", index: -1, imgPos: {}, labelList: [], textName: "", textId: "", audioName: "", audioId: "" };
      if (this.uploadFilePreview.length === 0) {
        this.textPreview = '';
      }
      if (modelType == 1 || modelType == 3 || modelType == 4 || modelType == 5) {
        this.verifyResult.splice(index, 1);
      }
      if (modelType == 2) {
        this.verifyResultImg.splice(index, 1);
      }
      if (modelType == 6) {
        this.verifyResultAudio.splice(index, 1);
      }
      // this.$forceUpdate() // 强制更新数据
      let uploadLength = this.uploadFilePreview.length;
      if (uploadLength % 5 === 0) { // 取模5（余数）等于0触发上一页
        if (modelType == 1 || modelType == 2) {
          this.$refs.imgSliderPrev.onSliderPrev(); // 图片调用子组件方法上一页
        } else if (modelType == 3 || modelType == 4) {
          this.$refs.txtSliderPrev.onSliderPrev(); // 文本调用子组件方法上一页
        } else if (modelType == 5 || modelType == 6) {
          this.$refs.audioSliderPrev.onSliderPrev(); // 音频调用子组件方法上一页
        }
      }
    },
    // 全部移除图片资料
    revokeObjectURL() {
      if (this.uploadFilePreview) {
        this.uploadFilePreview.forEach(item => {
          window.URL.revokeObjectURL(item.imgUrl);
        });

        this.uploadFilePreview = [];
      }
    },
    // 发布模型
    releaseModel() {
      var trainingModel,
        trainModelId,
        modelId,
        Model = this.Model,
        data = {};

      // 无训练模型信息，直接返回
      if (!this.activeTrainingModel) {
        return;
      }
      trainingModel = this.TrainingModel.find(
        // item => item.trainModelId === this.activeTrainingModel || item.version === this.activeTrainingModel
        item => item.algorithmId === this.activeTrainingModel || item.version === this.activeTrainingModel
      );
      //
      trainModelId = trainingModel.trainModelId;
      modelId = this.activeModel;
      data = { trainModelId };
      // 超级管理管理设置公开模型
      if (this.userRole == 4) {
        data.isPublic = this.commonModuleValue ? 1 : 0; // 是否公开模型：0为否，1为是
      }
      PRETRAIN.releaseModel(data).then(result => {
        if (result.isSuccess) {
          this.$message.success(result.returnMsg);
          this.$router.push({
            name: "model-list",
            params: { modeltype: this.modelType },
            query: { display: "version", modelId: modelId }
          });
          this.getModelPageIndex(); // 通过当前模型id获取“我的模型”页码
        }
      });
    },
    // 取消弹窗
    cancelPopup() {
      this.popupActive = "";
      // TODO:弹窗数据传递
      // this.popupData = this.Model.records[idx];
    },
    
    // 选中训练模型标签
    selectTrainingTags(vals) {
      let { Training, modelType } = this;
      this.unfinished = false; //初始化;
      // 图片分类、文本分类、文本标注、音频分类、音频标注
      if (modelType == 1 || modelType == 3 || modelType == 4 || modelType == 5 || modelType == 6) {
        this.unfinishedLabl = this.trainingRuleFunction (vals, 20); // 统计标签下数量,返回不符合标签
      } else { // 物体检测
        this.unfinishedLabl = this.trainingRuleFunction (vals, 40); // 统计标签下数量,返回不符合标签
      }

      this.labelNum = 0;
      this.labelIds = [];
      this.labelNames = [];
      this.Label.records.forEach(item => {
        this.Training.tags.forEach(i => {
          if (i == item.labelId) {
            this.labelNum += item.imgNum
            this.labelIds.push(item.labelId);
            this.labelNames.push(item.labelName);
          }
        });
      });
    },
    trainingRuleFunction (vals, num) {
      let { Label, modelType } = this;
      let arr = [];
      Label.records.forEach(item1 => {
        vals.forEach(item2 => {
          let imgNum = null;
          if (modelType == 1 || modelType == 2) {
            imgNum = item1.imgNum;
          } else if (modelType == 3 || modelType == 4) {
            imgNum = item1.textNum;
          } else {
            imgNum = item1.audioNum;
          }
          if (item2 === item1.labelId && imgNum < num) {
            this.unfinished = true;
            arr.push(item1.labelName);
          }
        });
      });
      return arr.toString();
    },
    // 验证集弹窗 'verification'
    openValidationSetPopup(val) {
      console.log(val)
      this.selectPopupActive = val
    },
    // 测试集弹窗 'test'
    openTestSetPopup(val) {
      console.log(val)
      this.selectPopupActive = val
    },
    // 移除信息
    handleDelete(index, row) {
      // this.tenantOrgRoleInfos.splice(index, 1)
    },
    // 确认自定义训练配置参数
    confirmConfiguration(val) {
      // console.log('自定义训练配置参数', val)
      // 判断清空数据不关闭弹窗
      if (val) { 
        this.trainModelConfigReq = val;
        this.cancelPopup(); // 取消弹窗
      } else {
        this.trainModelConfigReq = {};
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "./pretrain_common.scss";
@import "./ModelOperate.scss";
</style>
